export const useDates = () => {
    const getComparableTimeframe = (filterModel, key) => {
        return {
            compare: {
                ...filterModel,
                items: filterModel.items.map(item => {
                    if (item.field === key) {
                        const fromDate = new Date(item.value.from);
                        const toDate = new Date(item.value.to);
                        const delta = toDate - fromDate;
                        const newFrom = new Date(fromDate - delta).toISOString().split('T')[0];

                        return {
                            ...item,
                            value: {
                                ...item.value,
                                from: newFrom,
                                to: item.value.from
                            }
                        };
                    }
                    return item;
                })
            }
        };
    };
    

    return {
        getComparableTimeframe
    }
};
